module.exports = __webpack_public_path__ + "img/Icon2.53e84a37.webp";